/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * useLayoutPreferences.ts — us\1 \2ayou\1 \2references (services/operator-web-app).
 */

/**
 * E4-S1 T3: Hook for layout preferences with localStorage persistence.
 */
import { useState, useCallback } from 'react';
import {
  getCopilotCollapsed,
  setCopilotCollapsed as persistCopilotCollapsed,
} from '@/config/layoutPreferences';

export function useCopilotCollapsed(): [boolean, (collapsed: boolean) => void] {
  const [collapsed, setCollapsedState] = useState(getCopilotCollapsed);

  const setCollapsed = useCallback((value: boolean) => {
    setCollapsedState(value);
    persistCopilotCollapsed(value);
  }, []);

  return [collapsed, setCollapsed];
}
